module.exports = __webpack_public_path__ + "images/2953f9273ae03d7df8b57d536fb746b2396bb066e492b3482fd3d9cdaac8f566.svg";